import localization from "assets/localization/localization";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import LabelInput from "components/sales/Input/labelInput/labelInput";
import Loader from "components/sales/Loader/loader";
import ButtonWithIcon from "components/sales/buttons/buttonWithIcon/buttonWithIcon";
import { useEffect, useRef, useState } from "react";
import Regex from "services/utils/regex/Regex";
import "./authNew.css";
import { useSignin } from "./hooks/useSignIn";

export const AuthNew = ({
  tryGoogleAuthorisedUserLogin,
  generateOtp,
  login_data = [],
  history,
  otp
}) => {
  const [userId, setUserId] = useState("");
  const [isError, setIserror] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [roleId, setRoleId] = useState(null);
  const { requestSSO, loading } = useSignin({
    generateOtp,
    tryGoogleAuthorisedUserLogin,
  });

  const userIdRef = useRef(null);
  useEffect(() => {
    userIdRef.current.focus();
  }, [userIdRef]);

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    if (Regex.email.test(userId)) {
      setIserror("");
      setIsLoading(true);
      const res = await generateOtp(userId);
      setIsLoading(false);
      if (res === true) {
        var fusionState = localStorage.getItem("fusion-state")
          ? localStorage.getItem("fusion-state")
          : null;
        if (fusionState) {
          history.push({
            pathname: "/login-otp",
            state: { otp: otp, email: userId },
          });
        } else {
          setActiveStep(1);
        }
      }
    } else {
      if (userId === "") {
        setIserror(localization.mandatoryField);
      } else setIserror(localization.loginErrorMg);
    }
  };

  return (
    <div className="root">
      <div className="form">
        <div className="logo">
          <img
            src="https://leadx-stg.parkplus.io/img/login_logo.png"
            alt="Logo"
          />
        </div>
        <div className="title">Fusion</div>
        <div className="subtitle">Welcome Back!</div>
        <Loader isLoading={isLoading} />
        <div className="formWrapper">
          {activeStep === 0 && (
            <form onSubmit={handleSubmit}>
              <div className="inputWrapper">
                <LabelInput
                  ref={userIdRef}
                  className={`${userId.length ? "" : "empty"}`}
                  inputValue={userId}
                  handleChange={(e) => setUserId(e.target.value.trim())}
                  type="text"
                  label={localization.emailIdNo}
                  errorMsg={isError}
                />
              </div>

              <div className="form-stat">
                <div className="New-form">
                  <ButtonWithIcon title={localization.reqOtp} type="submit" />
                </div>
              </div>
            </form>
          )}
          {activeStep === 1 && (
            <form onSubmit={(e) => e.preventDefault()}>
              {login_data.length !== 0 ? (
                <div className="inputWrapper">
                  <DropDownInput
                    disabled={login_data.length === 0}
                    label={`Select Role`}
                    data={login_data}
                    getIdValue={(val) => {
                      setRoleId(val.id);
                    }}
                    required
                    errorMsg="Please select a role*"
                    isStarRequired
                  />
                </div>
              ) : (
                ""
              )}
              <div className="form-stat">
                <div className="New-form">
                  <ButtonWithIcon
                    title="Log In"
                    type="button"
                    onClick={() => {
                      requestSSO({ role_id: roleId });
                    }}
                    disabled={loading}
                  />
                </div>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};
